var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalanderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.168H5V8.16797H19M16 1.16797V3.16797H8V1.16797H6V3.16797H5C3.89 3.16797 3 4.05797 3 5.16797V19.168C3 19.6984 3.21071 20.2071 3.58579 20.5822C3.96086 20.9573 4.46957 21.168 5 21.168H19C19.5304 21.168 20.0391 20.9573 20.4142 20.5822C20.7893 20.2071 21 19.6984 21 19.168V5.16797C21 4.63754 20.7893 4.12883 20.4142 3.75376C20.0391 3.37868 19.5304 3.16797 19 3.16797H18V1.16797M17 12.168H12V17.168H17V12.168Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderIcon);
export default __webpack_public_path__ + "static/media/CalanderIcon.a4286fe336c4fd20278b03427abc8355.svg";
export { ForwardRef as ReactComponent };